import api from '../../services/api';

// Helpers shared by the document pages.

/** Where a document opens (a new tab; the server checks who may see it). */
export const viewUrl = (id) => `${api.defaults.baseURL || '/api'}/lifecycle/documents/${id}/view`;

export const kindLabel = (meta, kind) => meta?.kindLabels?.[kind] || meta?.uploadKindLabels?.[kind] || kind;

export const fmtSize = (n) => (n ? (n > 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`) : '');

/** {{extra.x}} fields a template asks for, with readable labels. */
export const extraFields = (template) => {
    const keys = [...new Set([...`${template?.subject || ''}\n${template?.body || ''}`.matchAll(/\{\{\s*extra\.([a-zA-Z][a-zA-Z0-9_]*)\s*\}\}/g)].map(m => m[1]))];
    return keys.map(k => ({ key: k, label: k.replace(/_/g, ' ').replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/^./, c => c.toUpperCase()) }));
};

const shortDate = (key) => new Date(`${key}T00:00:00Z`).toLocaleDateString(undefined, { day: 'numeric', month: 'short', timeZone: 'UTC' });
/** "Due 2 Nov" or "Overdue (30 Oct)" for a task. */
export const dueText = (t) => (t.overdue ? `Overdue (${shortDate(t.dueDate)})` : `Due ${shortDate(t.dueDate)}`);

export const longDate = (key) => new Date(`${key}T00:00:00Z`).toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
export const dateWithYear = (key) => new Date(`${key}T00:00:00Z`).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });

export const ACCEPT = 'application/pdf,image/png,image/jpeg,image/webp';
